var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'switch-wrapper',
    { 'disabled-element': _vm.disabled, 'deactived-element': _vm.deactived } ]},[_c('input',{ref:"input",attrs:{"disabled":_vm.disabled || _vm.deactived,"type":"checkbox"},domProps:{"checked":_vm.checked && !_vm.disabled},on:{"change":_vm.toggle}}),_vm._v(" "),_c('span'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }